// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD8xxlECFplzdPspc4vcBlHH6LYIyGFMrk',
    authDomain: 'bringme-a412b.firebaseapp.com',
    databaseURL: 'https://bringme-a412b.firebaseio.com',
    projectId: 'bringme-a412b',
    storageBucket: 'bringme-a412b.appspot.com',
    messagingSenderId: '697961749658'
  }
};

